"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetCategories = GetCategories;

var _getDefault = require("./get-default");

function GetCategories(params) {
  var arrayOfCategoryObjects = (0, _getDefault.GetDefault)(params);
  return arrayOfCategoryObjects.map(function (o) {
    return o.displayName;
  }).join(', ');
}